export function fadeIn(element, duration = 400) {
  element.style.opacity = 0
  element.style.display =
    getComputedStyle(element).display === 'none'
      ? 'block'
      : element.style.display

  const startTime = performance.now()

  function animate() {
    const elapsedTime = performance.now() - startTime
    element.style.opacity = Math.min(parseFloat(elapsedTime / duration), 1)

    if (elapsedTime < duration) {
      requestAnimationFrame(animate)
    }
  }

  requestAnimationFrame(animate)
}

export function fadeOut(element, duration = 400) {
  element.style.opacity = 1

  const startTime = performance.now()

  function animate() {
    const elapsedTime = performance.now() - startTime
    element.style.opacity = Math.max(parseFloat(1 - elapsedTime / duration), 0)

    if (elapsedTime < duration) {
      requestAnimationFrame(animate)
    } else {
      element.style.display = 'none'
    }
  }

  requestAnimationFrame(animate)
}
